import { memo } from 'react';

export default memo(
  function LiveNowIndicator({ receipts }: { receipts?: API.MessageReceipt[] }) {
    if (!receipts || !receipts.length) {
      return null;
    }

    const now = Date.now();
    let color1 = '';
    let color2 = '';
    let text = '';
    let ping = '';

    // Check the last 50 messages
    for (let i = 0; i < 50; i++) {
      const receipt = receipts[i];

      if (!receipt) {
        break;
      }

      const createdAt = +new Date(receipt.createdAt);
      const { content, release, notify } = receipt.message;

      if (now - createdAt > 60 * 60 * 4 * 1000) {
        // too old
        break;
      }

      const scheduled = content.match(
        /\W*(?:Next update:|planned for | at )\W*([0-9]{1,2}(:[0-9]{2})?\W*[ap]m\W*[A-Z]*)\W*[.!]*/i,
      );

      if (scheduled && notify !== 'releaseWarning' && !release) {
        color1 = 'bg-amber-500/75';
        color2 = 'bg-amber-500';
        text = `Update at ${scheduled[1]}`;
        break;
      }

      if (/^\W*(Done|No more releases)\W*([.!]*|for )/i.test(content)) {
        color1 = 'bg-zinc-500/75';
        color2 = 'bg-zinc-500';
        text = 'Done for now';
        break;
      } else if (notify === 'releaseWarning') {
        color1 = 'bg-amber-500/75';
        color2 = 'bg-amber-500';
        text = 'About to start';
        ping = 'animate-ping';
        break;
      } else if (release || /^\W*GO\W*[.!]*$/i.test(content)) {
        color1 = 'bg-red-500/75';
        color2 = 'bg-red-500';
        text = 'Live now';
        ping = 'animate-ping';
        break;
      } else if (
        /^\W*(We will start in|We will get started in|Will get started in|Will get started shortly|Next prop in [0-9]+ (?:seconds|minutes)|Here we go...|About to start)\W*([.!]*|for )/i.test(
          content,
        )
      ) {
        color1 = 'bg-amber-500/75';
        color2 = 'bg-amber-500';
        text = 'About to start';
        ping = 'animate-ping';
        break;
      }
    }

    return (
      <>
        {text && (
          <div className="flex flex-row items-baseline space-x-2">
            <div className="relative my-auto flex h-3 w-3">
              <span
                className={`absolute inline-flex h-full w-full ${ping} rounded-full ${color1}`}
              />
              <span className={`relative m-auto inline-flex h-2 w-2 rounded-full ${color2}`} />
            </div>
            <span className="text-xs text-zinc-900 dark:text-zinc-200">{text}</span>
          </div>
        )}
      </>
    );
  },
  (prevProps, nextProps) =>
    prevProps.receipts === nextProps.receipts &&
    prevProps.receipts?.length === nextProps.receipts?.length &&
    prevProps.receipts?.[0]?.message.content === nextProps.receipts?.[0]?.message.content &&
    prevProps.receipts?.[0]?.id === nextProps.receipts?.[0]?.id &&
    prevProps.receipts?.[49]?.id === nextProps.receipts?.[49]?.id,
);
